import { render } from "./formInputGroup.vue?vue&type=template&id=510afde0&scoped=true"
import script from "./formInputGroup.vue?vue&type=script&lang=js"
export * from "./formInputGroup.vue?vue&type=script&lang=js"

import "./formInputGroup.vue?vue&type=style&index=0&id=510afde0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src901110558/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510afde0"]])

export default __exports__